import './index.scss'

/** 加载动画组件 — 流式生成时显示 */
export default function Loading() {
  return (
    <div className="prd-loading">
      <span className="prd-loading-dot" /> 正在分析需求…
    </div>
  )
}
